import { useState, useEffect } from 'react';

import { useSelector } from 'react-redux';

import AmenitiesTable from './AmenitiesTable';
import CostTable from './CostTable';
import DetailsTable from './DetailsTable';
import NotesTable from './NotesTable';
import classes from './ShortlistTable.module.css';
import TourTable from './TourTable';

import {
  getUniqueListBy,
  formatDatefromTimeStamp,
  formatDateTime,
  splitMyString,
  strToArray,
  changeRequestedDate,
} from '../../utils/utils';
// import { id } from 'date-fns/locale';

const ShortlistTable = ({ content, surveyData, currentDeal }) => {
  const shortlist = useSelector((state) => state.shortlistRed.shortlistedOptions);

  shortlist.map((option) => {
    if (option?.images) {
      const customImages = option?.images;

      option.floorPlan ? customImages.unshift(option.floorPlan) : '';

      option.scheduleDate = option?.tourScheduledDate + ' ' + option?.tourScheduledSlot;
      if (option?.tourRequestedDate && !option.tourCompleted) {
        option.requestedDate =
          option.tourRequestedDate &&
          option.tourRequestedDate?.length > 0 &&
          option.tourRequestedDate[0].split('-').shift();
      }

      if (option?.tourRequestedDate && option?.tourRequestedDate?.length > 0) {
        const requestedDatesArray = [];

        if (typeof option?.tourRequestedDate === 'string') {
          option.tourRequestedDate = strToArray(option?.tourRequestedDate);
        }

        option?.tourRequestedDate?.filter((x) => {
          const reqDate = x.split(' - ');

          if (reqDate.some((item) => item.trim().toLowerCase() === 'morning')) {
            requestedDatesArray.push(reqDate[0] + ' 10:00 AM');
          } else {
            requestedDatesArray.push(reqDate[0] + ' 12:00 PM');
          }
          requestedDatesArray.sort();

          option.requestedDateTime = requestedDatesArray;
        });
      }
      if (option?.requestedDateTime && option?.requestedDateTime?.length > 0) {
        const sortedRequestedDates = [];

        option?.requestedDateTime.filter((x) => {
          const reqDate = splitMyString(x, 2);

          if (reqDate.includes('AM')) {
            sortedRequestedDates.push(changeRequestedDate(reqDate[0]) + ' - Morning');
          } else {
            sortedRequestedDates.push(changeRequestedDate(reqDate[0]) + ' - Afternoon');
          }
          option.sortedRequestedDates = sortedRequestedDates;
        });
      }

      if (option.requestedDateTime && option.tourCompleted == false) {
        option.requestedDate =
          option.requestedDateTime &&
          option.requestedDateTime?.length > 0 &&
          formatDateTime(option.requestedDateTime[0]);
      }

      if (option.tourScheduledDate) {
        const sdate =
          formatDatefromTimeStamp(option.tourScheduledDate, 'MMM DD, YYYY') +
          ' ' +
          option.tourScheduledSlot;

        option.scheduleDate = sdate;
      }
    }
  });

  return (
    <table className={classes['shortlist__table']}>
      {content === 'DETAILS' && <DetailsTable shortlist={shortlist} currentDeal={currentDeal} />}
      {content === 'AMENITIES' && <AmenitiesTable shortlist={shortlist} />}
      {content === 'COST' && <CostTable shortlist={shortlist} />}
      {content === 'NOTES' && <NotesTable shortlist={shortlist} surveyData={surveyData} />}
      {content === 'TOUR' && <TourTable shortlist={shortlist} surveyData={surveyData} />}
    </table>
  );
};

export default ShortlistTable;
